import { render } from "./SideBtns.vue?vue&type=template&id=6694dd04&scoped=true"
import script from "./SideBtns.vue?vue&type=script&lang=js"
export * from "./SideBtns.vue?vue&type=script&lang=js"

import "./SideBtns.vue?vue&type=style&index=0&id=6694dd04&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6694dd04"]])

export default __exports__